/**
 * Lookup order for a language code: the full tag first, then its primary subtag
 * (`'en-US'` → `['en-us', 'en']`). Pure and isomorphic — shared by backend, bot and frontends.
 */
export function getLanguageCandidates(languageCode: string): string[] {
  const normalized = languageCode.trim().toLowerCase();
  const primary = normalized.split('-')[0] ?? normalized;
  return primary === normalized ? [normalized] : [normalized, primary];
}
